import { Property } from '@/components/form/fields/select/SelectInput';
import { DEFAULT_DEVICE_FEE_NAME } from '@/services/catalogue/useDeviceFee';
import { useDeviceFees } from '@/services/catalogue/useDeviceFees';
import { usePoSelectDeviceFee, usePoSelectedDeviceFee } from '@/services/purchaseOrders/usePurchaseOrderService';
import { FunctionComponent, useMemo } from 'react';
import { PurchaseOrderConfirmOrderDeviceTableGrouped } from './table/PurchaseOrderConfirmOrderDeviceTableGrouped';

interface PurchaseOrderConfirmOrderDeviceSectionProps {}

const PurchaseOrderConfirmOrderDeviceSection: FunctionComponent<PurchaseOrderConfirmOrderDeviceSectionProps> = () => {
  const deviceFees = useDeviceFees();

  const selectedDeviceFee = usePoSelectedDeviceFee();
  const selectDeviceFee = usePoSelectDeviceFee();

  const options: Property[] = useMemo(() => {
    return [
      ...deviceFees.map(m => {
        return {
          name: m.name,
          id: m.id
        };
      })
    ].sort((a, b) => {
      // If both names are the target, keep order
      if (a.name === DEFAULT_DEVICE_FEE_NAME && b.name === DEFAULT_DEVICE_FEE_NAME) return 0;
      // If only a is the target, move it down
      if (a.name === DEFAULT_DEVICE_FEE_NAME) return 1;
      // If only b is the target, move it down
      if (b.name === DEFAULT_DEVICE_FEE_NAME) return -1;
      // Otherwise, sort alphabetically
      return a.name.localeCompare(b.name);
    });
  }, [deviceFees]);

  const onChange = (value: Property | null) => {
    if (value) {
      selectDeviceFee(value.id);
    }
  };

  const selectedOption = options.find(o => o.id === selectedDeviceFee?.id) ?? null;

  return (
    <div className="space-y-2 !mt-7">
      <PurchaseOrderConfirmOrderDeviceTableGrouped />
    </div>
  );
};

export default PurchaseOrderConfirmOrderDeviceSection;
